import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@atlassian/jira-skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { IssueTableGadgetEditData } from '../../../types.tsx';

const LazyAssignedToMeGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetEditData>>
>(() => import(/* webpackChunkName: "async-react-assigned-to-me-gadget-edit" */ './main'));

export const AssignedToMeGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetEditData>,
): React.JSX.Element => (
	<Placeholder name="assigned-to-me-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyAssignedToMeGadgetEdit {...props} />
	</Placeholder>
);

export const { preload } = LazyAssignedToMeGadgetEdit;
